import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React, { useState, useEffect } from 'react';
import { Grid, Typography } from '@material-ui/core';
import FormField from './Field';
import StyledText from '../fields/StyledTextInput';
import fieldLogic from '../logic/fieldsLogic';
import Utils from '../../../../utils';
import store from '../../../../store';
var LoginFields = [{
  name: 'Url',
  label: 'Ecrion URL'
}, {
  name: 'Username',
  label: 'User name'
}, {
  name: 'Password',
  label: 'Password'
}, {
  name: 'Environment',
  label: 'Environment'
}];

var getToken = function getToken(_ref) {
  var Username = _ref.Username,
      Password = _ref.Password,
      Environment = _ref.Environment,
      Url = _ref.Url;
  var authorization = "".concat(Username, ":").concat(Password);
  if (Environment) authorization = "".concat(Environment, "#").concat(authorization);
  authorization = btoa(authorization);
  return Utils.request({
    url: "".concat(Url, "/interop/token"),
    method: 'GET',
    headers: {
      Authorization: "Basic ".concat(authorization)
    }
  });
};

var ConnectedLoginFields = function ConnectedLoginFields(_ref2) {
  var fieldId = _ref2.fieldId,
      variant = _ref2.variant,
      dispatch = _ref2.dispatch,
      labelPlacement = _ref2.labelPlacement,
      value = _ref2.value,
      error = _ref2.error;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      token = _useState2[0],
      setToken = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      refreshToken = _useState4[0],
      setRefreshToken = _useState4[1];

  useEffect(function () {
    var newValue = _objectSpread({}, value, {
      Token: token
    });

    fieldLogic.onChange(fieldId, newValue, dispatch);
  }, [token]);

  var onBlur = function onBlur() {
    if (!refreshToken) return;
    setRefreshToken(false);
    store.dispatch({
      type: 'AUTH_SET',
      payload: {
        disableAuthRedirect: true
      }
    });
    getToken(value).then(function (token) {
      return setToken(token);
    }).catch(function () {
      return setToken('');
    }).finally(function () {
      return store.dispatch({
        type: 'AUTH_SET',
        payload: {
          disableAuthRedirect: false
        }
      });
    });
  };

  var onChange = function onChange(e) {
    setRefreshToken(true);

    var newValue = _objectSpread({}, value, _defineProperty({}, e.target.name, e.target.value));

    fieldLogic.onChange(fieldId, newValue, dispatch);
  };

  return React.createElement(React.Fragment, null, LoginFields.map(function (_ref3) {
    var name = _ref3.name,
        label = _ref3.label;
    return React.createElement(Grid, {
      style: {
        marginBottom: 15
      }
    }, React.createElement(FormField, {
      label: label,
      labelPlacement: labelPlacement,
      key: name
    }, React.createElement(StyledText, {
      value: value[name] || '',
      name: name,
      type: name === 'Password' ? 'password' : 'text',
      onChange: onChange,
      onBlur: onBlur,
      variant: variant,
      error: !!error
    })));
  }), error && React.createElement(Grid, {
    container: true,
    justify: "flex-end"
  }, React.createElement(Grid, {
    item: true,
    xs: 8
  }, React.createElement(Typography, {
    component: "div",
    color: "error",
    style: {
      marginLeft: 10
    }
  }, error))));
};

export default React.memo(ConnectedLoginFields);